var React = require('react');
var sdk = require('require-sdk')('https://www.youtube.com/iframe_api', 'YT');
var loadTrigger = sdk.trigger();

// YT API requires global ready event handler
window.onYouTubeIframeAPIReady = function () {
  loadTrigger();
  delete window.onYouTubeIframeAPIReady;
};


var Player = React.createClass({
  getInitialState: function(){
    return {player: {}};
  },

  componentDidMount: function() {
    var that = this;

    this._isPlaying = false;

    // called once API has loaded.
    sdk(function(err, youtube) {
      var player = new youtube.Player("youtube-player", {
        //videoId: that.props.videoId,
        width: '100%',
        playerVars: {
          playsinline: 1
        },
        events: {
          'onReady': that.props.playerReady,
          'onStateChange': that._handlePlayerStateChange
        }
      });

      that.setState({player: player});
    });

    var scIframe = this.refs.scPlayerFrame;
    scIframe.src = 'https://w.soundcloud.com/player/?url=';
    var scPlayer = SC.Widget(scIframe);
    scPlayer.bind(SC.Widget.Events.PLAY, this._videoStarted);
    scPlayer.bind(SC.Widget.Events.PAUSE, this._videoStopped);
    scPlayer.bind(SC.Widget.Events.FINISH, this._videoEnded);
    this.setState({scPlayer: scPlayer});

    this._activatePlayer('youtube');
  },

  componentWillUpdate: function(nextProps, nextState) {
    if (nextProps.video && (!this.props.video || this.props.video.id !== nextProps.video.id)) {
      this._loadNewVideo(nextProps.video);
    } else if (this.props.position !== nextProps.position && this.state.player.getPlayerState && !this.state.player.getPlayerState()){
      this._loadNewVideo(nextProps.video);
    }

    if(nextProps.playing && !this.props.playing && !this._videoIsPlaying()){
      this._playCurrentVideo();
    } else if(!nextProps.playing && this.props.playing && this._videoIsPlaying()){
      this._pauseCurrentVideo();
    }
  },

  _loadNewVideo: function(video) {
    this._activatePlayer(video.source);

    console.log('load new video', video)

    switch(video.source){
      case 'soundcloud':
        this._loadNewSCTrack(video);
        break;
      default: //case 'youtube'
        this._loadNewYTVideo(video);
        break;

    }
  },

  _loadNewYTVideo: function(video){
    if(this.state.player.loadVideoById){
      this.props.playing ?
        this.state.player.loadVideoById(video.id, 0, "hd720") :
        this.state.player.cueVideoById(video.id);

      this.state.player.setPlaybackQuality("hd720");
      this.refs.curtain.style.display = 'none';
    } else {
      console.warn('* Player: Can\'t play yet!');
    }
  },

  _loadNewSCTrack: function(video){
    this.state.scPlayer.load(video.url, {auto_play: this.props.playing});
  },

  _pauseCurrentVideo: function(){
     switch(this.props.video.source){
        case 'youtube':
          this.state.player.pauseVideo();
          break;

        case 'soundcloud':
          this.state.scPlayer.pause()
          break;
     }
  },

  _playCurrentVideo: function(){
    console.log(this.props)
    if(!this.props.video) {
      console.warn('_playCurrentVideo with no props.video');
      return;
    }

    console.log('play current video')

     switch(this.props.video.source){
        case 'youtube':
          this.state.player.playVideo();
          break;

        case 'soundcloud':
          this.state.scPlayer.play()
          break;
     }
  },

  _activatePlayer: function(source){
    this._isPlaying = false;

    switch(source){
      case 'youtube':
        this.refs.ytPlayer.style.display = 'block';
        this.refs.scPlayer.style.display = 'none';
        this.state.scPlayer && this.state.scPlayer.pause();
        break;

      case 'soundcloud':
        this.refs.scPlayer.style.display = 'block';
        this.refs.ytPlayer.style.display = 'none';
        this.state.player && this.state.player.pauseVideo();
        break;
    }

  },

  _videoIsPlaying: function(){
    return this._isPlaying;
  },

  _handlePlayerStateChange: function(event) {
    switch(event.data) {
      case 0:
        this._videoEnded();
        break;

      case 1:
        this._videoStarted();
        break;

      case 2:
        this._videoStopped();
        break;

      default:
        return;
    }
  },

  _videoStarted: function(){
    this._isPlaying = true;
    this.props.started();
  },

  _videoStopped: function(){
    this._isPlaying = false;
    this.props.stopped();
  },

  _videoEnded: function(){
    this._isPlaying = false;
    this.props.ended();
  },

  render: function() {
    return (
      <div className="players">
        <div className="youtube-player-container" ref="ytPlayer">
          <div className="curtain" ref="curtain"></div>
          <div id="youtube-player"></div>
        </div>
        <div className="soundcloud-player" ref="scPlayer">
          <iframe ref="scPlayerFrame"></iframe>
        </div>
      </div>
    );
  }

});

module.exports = Player;
